import { Box, Grid, Switch, Typography, useMediaQuery } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Slider from 'react-slick';
import Color from '../../layouts/Color';
import { formatMoney } from '../../utils/function/Function';
import { showConfirmActiveCardModal } from '../../redux/create-actions/ConfirmAction';
import { graphGetAllContractByCustomer } from '../../services/Contract';
import { useTheme } from '@emotion/react';

// ==============================|| Card Slick ||============================== //

const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplaySpeed: 4000,
    autoplay: false,
    arrows: true,
    swipe: false,
    responsive: [
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
                speed: 1000,
                autoplay: true,
                autoplaySpeed: 4000,
                pauseOnHover: true,
                arrows: true,
                swipe: false,
            }
        }
    ]
}

const box = {
    width: '100%',
    padding: 1,
}

const boxInner = {
    width: '100%',
}

const boxContentCard = {
    display: 'grid',
    gap: 1, 
    gridTemplateColumns: 'repeat(2, 2fr)',
    marginVertical: 5,
}

const titleStyle = { textAlign: 'left' };

const CardSlick = (props) => {
    const theme = useTheme()
    const matchDownSm = useMediaQuery(theme.breakpoints.down(('sm')));
    const data = useSelector(state => state.confirm.data);

    const [contracts, setContracts] = useState([]);

    const dispatch = useDispatch();

    useEffect(() => {
        const promise = graphGetAllContractByCustomer();
        promise.then((result) => {
            setContracts(result.items);
        }).catch(error => {
            const err = JSON.parse(JSON.stringify(error));
            console.log(err);
        })
    }, [dispatch, data.active]);

    const handleActiveCard = (contractId, status) => {
        dispatch(showConfirmActiveCardModal(
            'Confirm To Do Next Step', 
            `Do you want to continue to ` + (status === 'Card OK' ? 'lock card?' : 'active card?'), 
            contractId, 
            status === 'Card OK' ? "LOCK_CARD" : "ACTIVE_CARD"));
    };

    return (
        <Box sx={box}>
            <Slider {...settings}>
                {
                    contracts.map((contract, index) => (
                        <Box sx={boxInner} key={index} paddingX={1}>
                            <Grid container alignItems='center' justifyContent='center'>
                                <Grid item md={3} sm={4}>
                                    <img src={process.env.PUBLIC_URL + '/assets/images/dashboard/card_demo2.png'} alt='demo-card'></img>
                                </Grid>
                                <Grid item md={1} sm={1}>
                                
                                </Grid>
                                <Grid item md={8} sm={7} marginTop={matchDownSm ? 1 : 0}>
                                    <Box sx={boxContentCard}>
                                        <Typography variant="h3" sx={{
                                            ...titleStyle,
                                            fontSize: matchDownSm ? '1rem' : null
                                        }}>
                                            Account Balance
                                        </Typography>
                                        <Typography variant="h3" color={Color.Dangerous} sx={{
                                            fontSize: matchDownSm ? '1rem' : null
                                        }}>
                                            {formatMoney(contract.contractDetails.way4Response.data.balance.replace(/-/g, " "), ' VND')}
                                        </Typography>
                                        <Typography variant="h4" color={Color.Normal} sx={{
                                            ...titleStyle,
                                            fontSize: matchDownSm ? '0.8rem' : null
                                        }}>
                                            Card Number
                                        </Typography>
                                        <Typography variant="h4" color={Color.Normal} sx={{
                                            fontSize: matchDownSm ? '0.8rem' : null
                                        }}>
                                            {contract.contractNumber}
                                        </Typography>
                                        <Typography variant="h4" color={Color.Normal} sx={{
                                            ...titleStyle,
                                            fontSize: matchDownSm ? '0.8rem' : null
                                        }}>
                                            Account Number
                                        </Typography>
                                        <Typography variant="h4" color={Color.Normal} sx={{
                                            fontSize: matchDownSm ? '0.8rem' : null
                                        }}>
                                            {contract.way4Contract}
                                        </Typography>
                                        <Typography variant="h4" color={Color.Normal} sx={{
                                            ...titleStyle,
                                            fontSize: matchDownSm ? '0.8rem' : null
                                        }}>
                                            Card Type
                                        </Typography>
                                        <Typography variant="h4" color={Color.Normal} sx={{
                                            fontSize: matchDownSm ? '0.8rem' : null
                                        }}>
                                            {contract.contractType}
                                        </Typography>
                                        <Grid>
                                            <Typography variant="h4" color={Color.Normal} sx={{
                                            ...titleStyle,
                                            fontSize: matchDownSm ? '0.8rem' : null
                                        }}>
                                                Status
                                            </Typography>
                                        </Grid>
                                        <Grid justifyContent='center'>
                                            <Switch
                                                checked={contract.contractDetails.way4Response.data.status === "Card OK" ? true : false}
                                                onChange={() => handleActiveCard(contract.id, contract.contractDetails.way4Response.data.status)}
                                                size={!matchDownSm ? 'medium' : 'small'}
                                            />
                                        </Grid>
                                    </Box >
                                </Grid>
                            </Grid>
                        </Box>
                    ))
                }

            </Slider>
        </Box>
    );
};


export default CardSlick;
